
import { Database, Award, Star } from "lucide-react";
import { Card } from "@/components/ui/card";
import EvidenceQualityMeter from "@/components/EvidenceQualityMeter";

interface EvidenceOverviewProps {
  evidenceLevel: string;
  confidence: number;
  totalEvidence: number;
  relevantResearchCount: number;
}

const EvidenceOverview = ({ 
  evidenceLevel, 
  confidence, 
  totalEvidence, 
  relevantResearchCount 
}: EvidenceOverviewProps) => {
  return (
    <Card className="p-6 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 shadow-lg">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <EvidenceQualityMeter
          evidenceLevel={evidenceLevel as 'high' | 'medium' | 'low'}
          studyCount={relevantResearchCount}
          confidence={confidence}
          sources={['PubMed', 'TRIP Database', 'NHS Guidelines', 'FDA Safety']}
          showDetails={false}
        />
        
        <Card className="p-4 bg-white/80 backdrop-blur-sm">
          <div className="text-center">
            <Database className="h-8 w-8 text-blue-600 mx-auto mb-2" />
            <div className="text-2xl font-bold text-blue-600">
              {totalEvidence}
            </div>
            <div className="text-sm text-gray-600">Total Sources</div>
          </div>
        </Card>
        
        <Card className="p-4 bg-white/80 backdrop-blur-sm">
          <div className="text-center">
            <Award className="h-8 w-8 text-green-600 mx-auto mb-2" />
            <div className="text-lg font-bold text-green-600">
              {evidenceLevel.toUpperCase()}
            </div>
            <div className="text-sm text-gray-600">Evidence Quality</div>
          </div>
        </Card>
        
        <Card className="p-4 bg-white/80 backdrop-blur-sm">
          <div className="text-center">
            <Star className="h-8 w-8 text-purple-600 mx-auto mb-2" />
            <div className="text-lg font-bold text-purple-600">
              {confidence}%
            </div>
            <div className="text-sm text-gray-600">Confidence</div>
          </div>
        </Card>
      </div>
    </Card>
  );
};

export default EvidenceOverview;
